import { gql } from '../../../common/gql';

const userQuery = gql(/* GraphQL */ `
  query UserQuery {
    user {
      ...CurrentUserFragment
    }
  }
`);

export default userQuery;
